import { render, staticRenderFns } from "./IbDialogFooter.vue?vue&type=template&id=8a3dde02&scoped=true"
import script from "./IbDialogFooter.vue?vue&type=script&lang=js"
export * from "./IbDialogFooter.vue?vue&type=script&lang=js"
import style0 from "./IbDialogFooter.vue?vue&type=style&index=0&id=8a3dde02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3dde02",
  null
  
)

export default component.exports